export default function CipEnrollmentsColleges({collegeData, cip, localColleges}) {
    const collegeWithAwards = [...(new Set(collegeData && collegeData.matchCipFancyBasic.map(e => e.collegeName)))]
  return (

collegeData && localColleges && collegeData.matchCipFancyBasic &&
(localColleges.filter((f) => (collegeWithAwards.includes(f))).length > 0) && (

   <div className="bg-white p-8 mt-8 rounded-lg" id="collegeTable" >

<h3 className='text-2xl leading-7 mt-7 text-slate-700'>{`Local & State Postsecondary Degrees & Certificates Awarded in Similar Coursework`}</h3>

 {localColleges
 .filter((f) => (collegeWithAwards.includes(f)))
 .sort((a, b) => a > b ? 1 : -1)
 .map((e, i) => (

   <div key={`${e}-${i}`}>
<table

        className="table-fixed mt-6 relative w-full text-sm text-left text-stone-500 bg-white">
 <thead className="sticky print:relative top-[180px] h-8 text-slate-400 bg-white border-b-[1px] border-blue-200">
        <tr className="">
            <th colSpan="4" className="font-semibold px-2 text-lg text-slate-800">
            {e}
            </th>
            <th colSpan="2" className="font-light px-2 text-lg">

            </th>
            <th  colSpan="1" className="font-light px-2">
                2017
            </th>
            <th colSpan="1" className="font-light px-2">
                2018
            </th>
            <th colSpan="1" className="font-light px-2">
                2019
            </th>
            <th colSpan="1" className="font-light px-2">
                2020
            </th>
            <th colSpan="1" className="font-light px-2">
                2021
            </th>
        </tr>
    </thead>

   {(
        collegeData.matchCipFancyBasic
        .sort((a, b) => a.cipcode > b.cipcode ? 1 : -1)
        .map( (item, i) => (
item.collegeName === e && (

            (item.awards.map((aw, i) => (
            // aw.awardLevel === "Any Award" &&
            <tbody key={`${item.collegeName}${aw.awardLevel}`}>
        {item.awards.length < 3 ?
           i === 1 &&  <tr className={cip === item.cipcode ? ' font-semibold text-black hover:bg-blue-50' : 'text-stone-600 hover:bg-blue-50'}>

            <td colSpan="4" className="pl-10 py-1 truncate pr-4">  <span className={cip === item.cipcode ? ' tabular-nums font-semibold' : 'tabular-nums font-light'} >{`${item.cipcode.toString().replace(/\B(?=(\d{4})+(?!\d))/g, '.')}`}</span>
            <span className="pl-3" title={item.cipName}>{item.cipName}</span></td>
            <td colSpan="2" className="py-1 truncate font-light">
            <span className={cip === item.cipcode ? 'font-semibold' : 'font-light'} title={aw.awardLevel}>{aw.awardLevel}</span></td>


            <td colSpan="1" className="pl-2 py-1">{aw.numAwConferred[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</td>
            <td colSpan="1" className="pl-2 py-1">{aw.numAwConferred[1].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</td>
            <td colSpan="1" className="pl-2 py-1">{aw.numAwConferred[2].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</td>
            <td colSpan="1" className="pl-2 py-1">{aw.numAwConferred[3].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</td>
            <td colSpan="1" className="pl-2 py-1">{aw.numAwConferred[4].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</td>
            </tr>

            :

            <tr className={cip === item.cipcode ? 'font-semibold text-black hover:bg-blue-50' : 'text-stone-600 hover:bg-blue-50'}>
            { i === 0 ?
             <td colSpan="4" className="pl-10 py-1 truncate pr-4">  <span className={cip === item.cipcode ? ' tabular-nums font-semibold' : 'tabular-nums font-light'} >{`${item.cipcode.toString().replace(/\B(?=(\d{4})+(?!\d))/g, '.')}`}</span>
             <span className="pl-3" title={item.cipName}>{item.cipName}</span></td> : <td colSpan="4" className="pl-10 py-1 truncate pr-4 "> </td>}
             <td colSpan="2" className="py-1 truncate font-light">
             <span className={cip === item.cipcode ? 'font-semibold' : 'font-light'} title={aw.awardLevel}>{aw.awardLevel}</span></td>


             <td colSpan="1" className="pl-2 py-1">{aw.numAwConferred[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</td>
             <td colSpan="1" className="pl-2 py-1">{aw.numAwConferred[1].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</td>
             <td colSpan="1" className="pl-2 py-1">{aw.numAwConferred[2].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</td>
             <td colSpan="1" className="pl-2 py-1">{aw.numAwConferred[3].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</td>
             <td colSpan="1" className="pl-2 py-1">{aw.numAwConferred[4].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</td>
             </tr>

            }






            </tbody>

            )))
))

    ))}


</table></div>))}
   </div>
   ))}
